import React, {useMemo, useState, useEffect} from "react";
import "./../../utils/Style/pages/Employees.scss";
import {useTable} from "react-table";
import {faArrowDown, faUser} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Table from "../../components/Table";
import {setActionPayload, setActionType, setStatus} from "../../features/authorizationSlice";
import {ACTION_TYPES} from "../../app/actionTypes";
import {fetchEmployees, setEmployeesError} from "../../features/employeesSlice";
import {useDispatch, useSelector} from "react-redux";
import {isEmpty} from "lodash";
import {format} from "date-fns";
import {useOutletContext} from "react-router-dom";
import {Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay} from "@chakra-ui/react";
import TableSkeleton from "../../components/skeletons/TableSkeleton";
import {handleImageError} from "../../utils/functions";

function EmployeeBranchesTemplate() {
    const {loading} = useSelector((state) => state.employees);

    const [activeRowIndex, setActiveRowIndex] = useState(-1);
    const [employeesList, setEmployeesList] = useState([]);
    const [disabledEdit, setDisabledEdit] = useState(false);

    const [roles, setRoles] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [editId, setEditId] = useState(-1);

    const [employeeDetails, setEmployeeDetails] = useState({
        EmployeeID: "",
        FullName: "",
        Position: "",
        RoleID: "",
        BranchID: "",
        MobileNo: "",
        Email: "",
        isBlocked: false
    });

    const [editEmployeeDetails, setEditEmployeeDetails] = useState({
        EmployeeID: "",
        RoleID: "",
        newBranchID: "",
        oldBranchID: "",
        Email: "",
    });
    const [modalOpen, setModalOpen] = useState(false);

    const [onOpenQrAfterGenerate, onCloseQrReset] = useOutletContext();

    const dispatch = useDispatch();
    let {employees, positions} = useSelector(state => state.employees);
    let {branches} = useSelector(state => state.branches);

    useEffect(() => {
        dispatch(fetchEmployees());
        return () => {
            dispatch(setEmployeesError(null));
        };
    }, []);

    useEffect(() => {
        setEmployeesList(employees);
        setRoles(positions);
        if (!isEmpty(employees)) setIsDataLoaded(true);
    }, [employees]);

    const handleInputChange = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.value;
        setEditEmployeeDetails((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const onCloseQrWhilePending = () => {
        setStatus("CLOSED");
        onCloseQrReset();
    }

    const handleBlock = (id, branchId) => {
        const payload = {
            EmployeeId: id,
            BranchID: branchId
        }
        dispatch(setActionType(ACTION_TYPES.BLOCK_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }

    const handleDelete = (id, branchId) => {
        const payload = {
            EmployeeId: id,
            BranchID: branchId
        }
        setModalOpen(false);
        dispatch(setActionType(ACTION_TYPES.DELETE_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
    }

    const handleEdit = (id) => {
        editId === -1 ? setEditId(id) : setEditId(-1);
        setDisabledEdit(true);

        const role = roles.find((role) => role.label === employeeDetails.Position);
        const roleValue = role ? role.value : '';

        setEditEmployeeDetails({
            EmployeeID: employeeDetails.EmployeeID,
            RoleID: roleValue,
            newBranchID: employeeDetails.BranchID,
            oldBranchID: employeeDetails.BranchID,
            Email: employeeDetails.Email,
        });
    };

    const confirmEdit = (id) => {
        const payload = {
            EmployeeID: editEmployeeDetails.EmployeeID,
            RoleID: parseInt(editEmployeeDetails.RoleID),
            newBranchID: parseInt(editEmployeeDetails.newBranchID),
            oldBranchID: editEmployeeDetails.oldBranchID,
            Email: editEmployeeDetails.Email,
        }
        setModalOpen(false);
        setDisabledEdit(false);
        dispatch(setActionType(ACTION_TYPES.EDIT_EMPLOYEE));
        dispatch(setActionPayload(payload));
        onOpenQrAfterGenerate();
        setEditId(-1);
    }
    const handleClick = (row) => {
        setEmployeeDetails({
            EmployeeID: row.original.EmployeeID,
            FullName: row.original.FullName,
            Position: row.original.Position,
            BranchID: row.original.BranchID,
            MobileNo: row.original.MobileNo,
            Email: row.original.Email,
            isBlocked: row.original.isBlocked
        });
        setModalOpen(true);
    }

    const columns = useMemo(
        () => [

            {
                Header: "Employee Name",
                accessor: "FullName",
                Cell: ({row, cell: {value}}) => {
                    return <div className="showmore">
                        {
                            row.original.ImageURL ? (
                                <div className="row">
                                    <div className="col-1 p-0 avatar-employee"><img id="employeesListAvatar" src={row.original.ImageURL} alt="avatar" onError={handleImageError}/></div>
                                    <div className="col-9 pt-2">{value}</div>
                                </div>
                            ) : (
                                <div className="row-8 ">
                                    <span className="me-2"><FontAwesomeIcon icon={faUser}/></span> {value}
                                </div>
                            )

                        }
                    </div>
                },
            },
            {
                Header: "Position",
                accessor: "Position",
            },
            {
                Header: "",
                accessor: "details",
                Cell: ({row}) => {
                    return <button className="showmore" onClick={() => {
                        setActiveRowIndex(row.index)
                    }}><FontAwesomeIcon icon={faArrowDown}/></button>
                },
            },
            {
                Header: "Branch",
                // accessor: "BranchID",
                // Cell: ({value}) => {
                //
                // },
                accessor: "Description",
            },
            {
                Header: "Last Access Date",
                accessor: "DateLastAccess",
                Cell: ({value}) =>
                    value ? format(new Date(value), "dd/MM/yyyy") : value,
            },
            {
                Header: "Phone Number",
                accessor: "MobileNo",
            },
            {
                Header: "Email",
                accessor: "Email",
            },
            {
                Header: sessionStorage.getItem("EntityRole") === "Supervisor" ? "" : "Action",
                accessor: "Action",
                Cell: ({row}) => {
                    if (sessionStorage.getItem("EntityRole") === "Supervisor") {
                        return <></>
                    }
                    if (row.original.isBlocked) {
                        return <button className="details Unblock" onClick={() => {
                            handleBlock(row.original.EmployeeID, row.original.BranchID);
                        }}>Unblock</button>;
                    } else {
                        return <button className="details" onClick={() => {
                            handleBlock(row.original.EmployeeID, row.original.BranchID);
                        }}>Block</button>;
                    }
                },
            }
        ],
        []
    );
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow
    } = useTable({columns, data: employeesList || []});
    return (
        <>

            <div className="employeesTable">
                {
                    loading === "pending" ? (
                        <TableSkeleton/>
                    ) : (
                        <Table
                            headerGroups={headerGroups}
                            page={rows}
                            prepareRow={prepareRow}
                            getTableProps={getTableProps}
                            getTableBodyProps={getTableBodyProps}
                            activeRowIndex={activeRowIndex}
                            setActiveRowIndex={setActiveRowIndex}
                            //to disable edit for supervisors
                            employee={sessionStorage.getItem("EntityRole") !== "Supervisor"}
                            handleClick={handleClick}
                        />
                    )
                }
            </div>

            {/* Modal */}
            <div id="modal-part">
                <Modal isOpen={modalOpen} isCentered onClose={()=>{
                    setDisabledEdit(false);
                }}>
                    <ModalOverlay/>

                    <ModalContent maxW={'40%'}>
                        <ModalHeader>
                            <div id="modalHeader">
                                <div></div>
                                <h2>Employee Details</h2>
                                <button type="button" className="btn-close" onClick={() => {
                                    setModalOpen(false);
                                    setDisabledEdit(false)
                                }}></button>
                            </div>
                        </ModalHeader>
                        <ModalBody>
                            <div id="employee-modal">
                                <div className="chak-modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-body EditEmployee">
                                            <div className="modalBody">
                                                <div className="row modalRow">
                                                    <div className="col-3 subTitle">Name</div>
                                                    <div className="col-9 subDesc">{employeeDetails.FullName}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-3 subTitle">Position</div>
                                                    {/*{disabledEdit ?*/}
                                                    {/*    <select className="col-9 subDesc" name="RoleID" id="account"*/}
                                                    {/*            defaultValue={employeeDetails.Position}*/}
                                                    {/*            onChange={handleInputChange}>*/}
                                                    {/*        {roles.map((role) => <option key={role.value}*/}
                                                    {/*                                     value={role.value}>{role.label}</option>)}*/}
                                                    {/*    </select>*/}
                                                    {/*    :*/}
                                                    {/*    <div className="col-9 subDesc">{employeeDetails.Position}</div>*/}
                                                    {/*}*/}
                                                    <div className="col-9 subDesc">{employeeDetails.Position}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-3 subTitle">Branch</div>
                                                    {disabledEdit ?
                                                        // <input className="col-9 subDesc" defaultValue={employeeDetails.BranchID} />
                                                        <select className="col-9 subDesc" name="newBranchID"
                                                                id="account"
                                                                defaultValue={employeeDetails.BranchID}
                                                                onChange={handleInputChange}>
                                                            {branches.map((branch) => <option key={branch.BranchID}
                                                                                              value={branch.BranchID}>{branch.Name}</option>)}
                                                        </select>
                                                        :
                                                        <div className="col-9 subDesc">
                                                            {
                                                                branches.find(branch => branch.BranchID === employeeDetails.BranchID)?.Name
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-3 subTitle">Phone Number</div>
                                                    <div className="col-9 subDesc">{employeeDetails.MobileNo}</div>
                                                </div>
                                                <div className="row modalRow">
                                                    <div className="col-3 subTitle">Email</div>
                                                    <div className="col-9 subDesc">{employeeDetails.Email}</div>
                                                </div>
                                            </div>

                                            <div className="modalFooter">
                                                {
                                                    !employeeDetails.isBlocked &&
                                                    <>
                                                        {disabledEdit ?
                                                            <button className="EditEmployee" onClick={() => {
                                                                confirmEdit(employeeDetails.EmployeeID)
                                                            }}>Confirm Edit</button>
                                                            :
                                                            <button className="EditEmployee" onClick={() => {
                                                                const selectedRole = roles.find(role => role.label === employeeDetails.Position)?.value;
                                                                handleEdit(employeeDetails.EmployeeID, selectedRole);
                                                            }}>
                                                                Edit Details
                                                            </button>
                                                        }
                                                    </>
                                                }


                                                <button className="DeletEmployee" onClick={() => {
                                                    handleDelete(employeeDetails.EmployeeID, employeeDetails.BranchID)
                                                }}>Delete Employee
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </div>
        </>
    );
}

export default EmployeeBranchesTemplate;